import {
    post
} from "@/api/requrestHttp.js";
export const tabdata = {

    data() {
        return {
            tableData: [],
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1
            },
            tableDataUrl: '',
            searchlist: {}
        }
    },
    components: {},
    methods: {
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val;
            this.getPageDatas();
        },
        //条件查询
        // searchlistdata() {
        //     this.pageConfig.pageNo = 1
        //     this.getPageDatas()
        // },
        //条件查询重置
        // searchlistReset() {
        //     this.searchlist = {}
        //     this.pageConfig.pageNo = 1
        //     this.getPageDatas()
        // },
        //每页展示条数
        handleSizeChange(val) {
            this.pageConfig.pageSize = val
            this.pageConfig.pageNo = 1
            this.getPageDatas();
        },
        //获取列表数据
        getPageDatas(applyTypeList) {
            if (applyTypeList) this.pageConfig.applyTypeList = applyTypeList
            console.log('this.pageConfig:', this.pageConfig)
            post("/admin/attendanceRecord/info/list", {
                ...this.pageConfig,
                ...this.searchlist
            }).then((res) => {
                if (res.content) {
                    this.pageConfig.total = res.content.count;
                    this.tableData = res.content.list;
                } else {
                    this.pageConfig.total = 0;
                    this.tableData = []
                }
            }).catch((errer) => {
                this.tableData = [];
                this.pageConfig.total = 0;
                // this.$message.error("获取信息失败");
            })
        },
        initTableDataUrl(url, applyTypeList) {
            console.log('url:', url, applyTypeList)
            this.tableDataUrl = url;
            this.getPageDatas(applyTypeList)
        }
    }
}